import { Component, Input } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
    selector: 'app-error-message',
    templateUrl: './error-message.component.html',
    standalone: false
})
export class ErrorMessageComponent {
  @Input() inputVal: FormControl;
  @Input() isPass: boolean;
}
